<template>
	<div class="flex xs-12 xs-between xs-middle">
    
    <!-- Left -->
    <div class="flex xs-4 xs-center xs-middle">
      <!-- Previous Page -->
      <j-button class="xs mr1" type="secondary" size="small" @click="updatePage(previousPage())">
        <span class="xs-0 lg-flex">{{ $t("prev") }}</span>
        <crm-icon name="chevron-left" size="small" class="xs-flex lg-0"></crm-icon>
      </j-button>
      <!-- Page Number -->
      <j-base-input-number
        size="small"
        type="integer"
        v-model="pageNumber"
        @input="updatePage(pageNumber)"
        @enter="goToPage"
        class="xs-2 ta3"
      />
      <span class="pageNumber c1 pl1 mr1">/ {{ this.numPages }}</span>
      <!-- Next Page -->
      <j-button class="xs" type="secondary" size="small" @click="updatePage(nextPage())">
        <span class="xs-0 lg-flex">{{ $t("next") }}</span>
        <crm-icon name="chevron-right" size="small" class="xs-flex lg-0"></crm-icon>
      </j-button>
    </div>

    <!-- Right -->
    <div class="flex">
       <!-- Zoom Functions -->
      <div class="flex">
        <div class="flex pr1">
          <j-button size="small" type="quaternary" @click="$emit('zoomReset')">
            {{ $t("reset_zoom") }}
          </j-button>
        </div>
        <div class="flex pr1">
          <j-button size="small" type="quaternary" @click="$emit('zoomIn')">
            <crm-icon name="zoom-in" size="small" color="c1" />
          </j-button>
        </div>
        <div class="flex pr1">
          <j-button size="small" type="quaternary" @click="$emit('zoomOut')">
            <crm-icon name="zoom-out" size="small" color="c1" />
          </j-button>
        </div>
      </div>
    </div>

	</div>
</template>

<script>
import CrmIcon from "@/components/CrmIcon"
import JButton from "@/components/JButton"
import JBaseInputNumber from "@/components/JBaseInputNumber"
export default {
	components: {
		CrmIcon,
		JButton,
		JBaseInputNumber
	},
	props: {
		page: {
			type: Number,
			default: 1
		},
		numPages: {
			type: Number,
			default: null
		}
	},
	data: function() {
		return {
			pageNumber: this.page
		}
	},
	methods: {
		updatePage(value) {
			if (isNaN(parseInt(value))) return

			this.$emit("goToPage", parseInt(value))
		},
		previousPage() {
			if (this.pageNumber <= 1) return this.pageNumber
			this.pageNumber--
			return this.pageNumber
		},
		nextPage() {
			if (this.pageNumber >= this.numPages) return this.pageNumber
			this.pageNumber++
			return this.pageNumber
		},
		goToPage() {
			if (this.pageNumber >= 1 || this.pageNumber <= this.numPages) {
				this.updatePage(this.pageNumber)
			}
		}
	}
}
</script>

<style>
.pageNumber {
	font-size: calc(0.2rem + (0.2rem * 3));
}
</style>